import React from 'react';
import ReactDOM from 'react-dom/client';
import { RemoteDataProvider } from './providers/RemoteDataProvider';
import App from './App';
import reportWebVitals from './reportWebVitals';
import appStyles from './css/App.scss';

// https://www.figma.com/design/WqKM7IRnzb09C6w7A8UNz7/E3-DC-Landingpage?node-id=2142-2548&t=4RSYzIyDw9SJtcd8-0

const MAP_DEEPLINK_QUERY_PARAM = 'map_deeplink';

const getDeeplinkFromUrl = (url) => {
  if (!url) return '';

  try {
    const parsedUrl = new URL(url);
    const searchDeeplink = parsedUrl.searchParams.get(MAP_DEEPLINK_QUERY_PARAM);
    if (searchDeeplink) return searchDeeplink;

    const queryIndex = parsedUrl.hash.indexOf('?');
    if (queryIndex === -1) return '';

    return new URLSearchParams(parsedUrl.hash.substring(queryIndex)).get(MAP_DEEPLINK_QUERY_PARAM) || '';
  } catch (error) {
    return '';
  }
};

const getEmbeddedDeeplink = (element) => {
  const elementDeeplink = element.getAttribute('map_deeplink') || element.dataset.mapDeeplink || element.parentElement?.dataset.mapDeeplink || '';
  if (elementDeeplink) return elementDeeplink;

  const locationDeeplink = getDeeplinkFromUrl(window.location.href);
  if (locationDeeplink) return locationDeeplink;

  const referrerDeeplink = getDeeplinkFromUrl(document.referrer);
  if (referrerDeeplink) return referrerDeeplink;

  return '';
};

class E3DCMapShadowRootComponent extends HTMLElement {
  connectedCallback() {

    const shadowRoot = this.attachShadow({ mode: 'open' });
    const embeddedDeeplink = getEmbeddedDeeplink(this);

    if (!window.e3dcMapShadowRoot) {
      window.e3dcMapShadowRoot = shadowRoot;
    }

    const appStyleEl = document.createElement('style');
    appStyleEl.textContent = appStyles;
    shadowRoot.appendChild(appStyleEl);

    const container = document.createElement('div');
    shadowRoot.appendChild(container);

    ReactDOM.createRoot(container).render(
      <React.StrictMode>
        <RemoteDataProvider>
          <App embeddedDeeplink={embeddedDeeplink} />
        </RemoteDataProvider>
      </React.StrictMode>
    );
  }
}

// Define your custom element
if (!customElements.get('e3dc-map-shadow-root-component')) {
  customElements.define('e3dc-map-shadow-root-component', E3DCMapShadowRootComponent);
}
document.addEventListener('DOMContentLoaded', () => {
  const map = document.getElementById('e3dc-partner-map');
  if (map) {
    const customElement = document.createElement('e3dc-map-shadow-root-component');
    const embeddedDeeplink = map.dataset.mapDeeplink || getDeeplinkFromUrl(window.location.href) || getDeeplinkFromUrl(document.referrer);
    if (embeddedDeeplink) {
      customElement.setAttribute('map_deeplink', embeddedDeeplink);
    }
    map.appendChild(customElement);
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
